// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2KpS8","vLegacy":"SelectSecondary_vLegacy__NPiMf","error":"SelectSecondary_error__1lR6b","disabled":"SelectSecondary_disabled__3rr2c"};